export const minQueryLength = 3

export const categories = [
    {
        id: "group",
        tkey: "finder.calls",
        icon: "call",
        itemType: "group",
    },
    {
        id: "activity",
        tkey: "finder.activities",
        icon: "meeting",
        itemType: "activity",
    },
    {
        id: "resource",
        tkey: "finder.resources",
        icon: "paperclip",
        itemType: "resource",
    },
    {
        id: "program",
        tkey: "finder.programs",
        icon: "program",
        itemType: "program",
    },
    {
        id: "library",
        tkey: "finder.libraries",
        icon: "books",
        itemType: "library",
    },
    {
        id: "news",
        tkey: "finder.news",
        icon: "newspaper",
        itemType: "news",
    },
    {
        id: "post",
        tkey: "finder.posts",
        icon: "comment-alt-lines",
        itemType: "post",
    },
    {
        id: "forum",
        tkey: "finder.forums",
        icon: "comments-alt",
        itemType: "forum",
    },
    {
        id: "vc",
        tkey: "finder.virtualClassrooms",
        icon: "webcam",
        itemType: "vc",
    },
]
